import DeliveryOrderDetail from '@/models/DeliveryOrder/DeliveryOrderDetail';

export default class DeliveryOrderDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryOrderId  = '';
		this.deliveryOrderDoNumber = '';
		this.poNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtyPerUnit = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.poDetailId  = '';
		this.poDetailQtyPo = '';
		this.deliveryStatusId  = '';
		this.deliveryStatusName = '';
		this.doProgressStatusId  = '';
		this.doProgressStatusName = '';
		this.partDestinationId = '';
		this.destinationId = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryOrderId : '0',
			deliveryOrderDoNumber : '0',
			poNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qtyPerUnit : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			poDetailId : '0',
			poDetailQtyPo : '0',
			deliveryStatusId : '0',
			deliveryStatusName : '0',
			doProgressStatusId : '0',
			doProgressStatusName : '0',
			partDestinationId : '0',
			destinationId : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}